import Vue from 'vue'
import axios from 'axios';
import VueAxios from 'vue-axios';

axios.defaults.baseURL = `/`

Vue.use(VueAxios, axios);